"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('voice-message', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, _react.default.createElement("circle", {
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    fill: props.outFillColor,
    fillRule: "nonzero",
    strokeLinejoin: props.strokeLinejoin,
    cx: "20",
    cy: "20",
    r: "20"
  }), _react.default.createElement("g", {
    transform: "translate(11.000000, 10.000000)"
  }, _react.default.createElement("circle", {
    fill: props.innerStrokeColor,
    cx: "2",
    cy: "9.89949494",
    r: "2"
  }), _react.default.createElement("path", {
    d: "M6.94974747,14.8492424 C8.21649831,13.5824916 9,11.8324916 9,9.89949494 C9,7.96649831 8.21649831,6.21649831 6.94974747,4.94974747",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M11.8994949,19.7989899 C14.4329966,17.2654882 16,13.7654882 16,9.89949494 C16,6.03350169 14.4329966,2.53350169 11.8994949,5.68434189e-14",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  })))));
});

exports.default = _default;